export const OtpVerificationModalContent = {
  content: 'Did you obtain Voice Verification (VV) or One-Time Password (OTP)?',
  confirm: 'Yes',
  notApplicable: 'Not Applicable',
};
